import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { Event } from "../../types/Types";

type UpdateEventDto = Partial<Event>;

export const useSaveEvent = (
  options?: UseMutationOptions<
    Event,
    unknown,
    Event | UpdateEventDto,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<Event>) => {
      if (data.id) {
        return axiosInstance
          .put(getAPIURL(`/Event/Update`), data)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/Event/Create"), data)
          .then((res) => res.data);
      }
    },
  });
};
